import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { BannerStatus, BannerLayout } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Checkbox } from 'ui-components/components/checkbox';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { AddCsvFile } from '../../../../../../../../components/csv-import/ui/components/add-csv-file';
import { useImportContext } from '../../../../../../../../components/csv-import/ui/components/import-context';
import { InitErrors } from '../../../../../../../../components/csv-import/ui/components/init-errors/init-errors';
import { MappingList } from '../../../../../../../../components/csv-import/ui/components/mapping-list/mapping-list';
import { StepSuspense } from '../../../../../../../../components/csv-import/ui/components/step-suspense/step-suspense';
import { UPDATE_EXISTING_PRODUCTS } from '../reducer';
import { messages } from './messages';
import styles from './styles.module.less';

export const ConfigStep = () => {
  const { form, dispatch, isGetMappingsLoading, isInitImportLoading } = useImportContext();

  const onUpdateExistingProductChange = useCallback(() => {
    const newValue = !form.updateExistingProducts;
    dispatch({
      type: UPDATE_EXISTING_PRODUCTS,
      updateExistingProducts: newValue,
    });
  }, [dispatch, form.updateExistingProducts]);

  return (
    <StepSuspense isLoading={isGetMappingsLoading || isInitImportLoading}>
      <div className={styles['config-step-body']}>
        <InitErrors />
        <AddCsvFile name='fulfillment-product-import' />
        <Checkbox
          checked={form.updateExistingProducts}
          className={styles['update-checkbox']}
          label={<FormattedMessage {...messages.updateExistingProducts} />}
          onChange={onUpdateExistingProductChange}
        />
        {form.updateExistingProducts ? (
          <BannerMessageV2
            content={<Text textType={TextType.Caption} value={messages.fulfillmentBarcodeWarningMessage} />}
            layout={BannerLayout.Inline}
            status={BannerStatus.Warning}
          />
        ) : null}
        <FlexColumn className={styles['mapping-list-wrapper']}>
          <MappingList />
        </FlexColumn>
      </div>
    </StepSuspense>
  );
};
